import { ChatCardProps } from "./ChatCard";
import "./chat.module.css";
import { useState } from "react";
import CitationHandler from "./CitationHandler";
export const RenderCitations = ({
  isLoading,
  citations,
  onCitationClick,
}: ChatCardProps) => {
  const [showAll, setShowAll] = useState(false); // Add this
  const visibleCitations = showAll
    ? citations
    : citations && citations.slice(0, 5);

  return (
    <>
      {!isLoading &&
      citations &&
      Array.isArray(citations) &&
      citations.length > 0 ? (
        <div className="w-full">
          <div className="">
            <div className="text-sm text-gray-500">
              <b className="heading_text_color pl-2">Citations:</b>
              <ol className="list-decimal citation pl-6 ">
                {
                  visibleCitations?.map((item: any, index: number) => (
                    <li key={index} className="">
                      <CitationHandler
                        citation={item}
                        isLoading={isLoading}
                        onCitationClick={onCitationClick}
                      />
                    </li>
                  ))}
              </ol>
            </div>
            <div className="pl-2">
              {citations.length > 5 && (
                <button
                  onClick={() => setShowAll(!showAll)}
                  className="text-blue-300  hover:underline  text-sm mt-2"
                >
                  {showAll ? "Show less" : "Show more"}
                </button>
              )}
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};
